<template>
  <v-container fluid class="contratos-page">
    <div class="d-flex align-center flex-wrap mb-2" style="gap: 20px">
      <!-- <v-btn color="primary" @click.stop="items = []; getItems(loadpage)">
        <v-icon left>mdi-reload</v-icon>
        recargar
      </v-btn> -->
      <v-spacer></v-spacer>
      <v-btn
        small
        :loading="exporting"
        color="secondary"
        @click.stop="exportarTodos"
      >
        <v-icon left>mdi-microsoft-excel</v-icon>
        {{ $t("common.exportar") }}
      </v-btn>
    </div>
    <v-card>
      <div class="table-container">
        <app-table
          :search="search"
          :headers="headers"
          :items="visibleItems"
          item-key="ref"
          :loading="loading"
          show-select
          v-model="selected"
          :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageOptions: [rowsPerPage],
          }"
          hide-default-footer
          checkbox-color="secondary"
          @click:row="(_, { item }) => (detailsId = item.ref)"
        >
          <div class="scroll-top" ref="scrollTop" @scroll="syncScroll"></div>

          <template v-slot:body.prepend="{ headers }">
            <table-filters
              :headers="headers"
              :items="items"
              v-model="inlineFilters"
            />
          </template>
          <template v-slot:item.fecha_entrega="{ item }">
            {{ parseDate(item.fecha_entrega) }}
          </template>
          <template v-slot:item.fecha_alta_comercializadora="{ item }">
            {{ parseDate(item.fecha_alta_comercializadora) }}
          </template>
          <template v-slot:item.fecha_baja_comercializadora="{ item }">
            {{ parseDate(item.fecha_baja_comercializadora) }}
          </template>
          <template v-slot:item.TOTAL_COMPRA="{ item }">
            {{ item.TOTAL_COMPRA | eur }}
          </template>
          <template v-slot:item.verificado="{ item }">
            <v-icon v-if="item.verificado" color="success">mdi-phone</v-icon>
            <v-icon v-else color="warning">mdi-phone-alert</v-icon>
          </template>
          <template v-slot:item.estado="{ item }">
            <EstadoContrato block :estado="item.estado" />
          </template>
          <template v-slot:item.LLAMADA_VENTA="{ item }">
            <div class="d-flex">
              <span class="text-center mx-auto">{{
                item.LLAMADA_VENTA === null
                  ? "-"
                  : item.LLAMADA_VENTA
                  ? "Sí"
                  : "No"
              }}</span>
            </div>
          </template>
          <template v-slot:item.TEXTO_LEGAL="{ item }">
            <div class="d-flex">
              <span class="text-center mx-auto">{{
                item.TEXTO_LEGAL === null ? "-" : item.TEXTO_LEGAL ? "Sí" : "No"
              }}</span>
            </div>
          </template>
          <template v-slot:item.CERTIFICADO="{ item }">
            <div class="d-flex">
              <span class="text-center mx-auto">{{
                item.CERTIFICADO === null ? "-" : item.CERTIFICADO ? "Sí" : "No"
              }}</span>
            </div>
          </template>
          <template v-slot:item.llamada="{ item }">
            <v-menu open-on-hover v-if="item.llamada == 'INCIDENCIA'">
              <template v-slot:activator="{ attrs, on }">
                <v-chip
                  color="orange darken-2"
                  v-bind="attrs"
                  v-on="on"
                  label
                  outlined
                  >{{ item.llamada }}</v-chip
                >
              </template>
              <v-card max-width="400">
                <v-card-subtitle class="font-weight-bold">{{
                  item.motivo_incidencia
                }}</v-card-subtitle>
              </v-card>
            </v-menu>
            <span v-else>{{ item.llamada }}</span>
          </template>
        </app-table>
      </div>
    </v-card>

    <div class="d-flex align-center justify-end">
      <v-subheader>{{
        $t("common.cargados", { n: shownItemsCount, t: count })
      }}</v-subheader>
    </div>
    <div class="d-flex justify-center text-center py-2">
      <v-pagination
        v-model="page"
        :length="paginationLength"
        total-visible="7"
      ></v-pagination>
    </div>

    <v-dialog
      fullscreen
      transition="dialog-bottom-transition"
      :value="detailsId != null"
      @input="(v) => (v === false ? (detailsId = null) : null)"
    >
      <v-toolbar
        dense
        color="primary"
        style="position: sticky; top: 0; z-index: 10"
      >
        <v-spacer></v-spacer>
        <v-btn @click.stop="detailsId = null" icon color="white">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <DetalleContrato :key="detailsId" :detailsId="detailsId" />
    </v-dialog>
  </v-container>
</template>

<script>
import {
  perColumnFilter,
  parseDate,
  jsonToCsv,
  downloadFile,
} from "@/utils/index.js";

export default {
  components: {
    EstadoContrato: () => import("../components/EstadoContrato.vue"),
    TableFilters: () => import("@/components/TableFilters.vue"),
    DetalleContrato: () => import("./DetalleContrato.vue"),
    AppTable: () => import("@/components/AppTable.vue"),
  },
  props: {
    _detailsId: String | Number,
  },
  data() {
    return {
      items: [],
      headers: [],
      search: null,
      desde: null,
      hasta: null,
      loading: false,
      page: 1,
      pagesize: 1,
      loadsize: 1,
      pageCount: 1,
      rowsPerPage: 50,
      tableItemsPerPage: 200,
      backendPerPage: 200,
      maxSearchPerPage: 1000,
      serverPagination: true,
      globalFilterMode: false,
      detailsId: this._detailsId || null,
      count: 0,
      selected: [],

      exporting: false,
      inlineFilters: {},
    };
  },
  computed: {
    shownItemsCount() {
      return this.visibleItems.length;
    },

    filteredItemsForDisplay() {
      if (this.serverPagination) return this.items;
      if (!this.hasActiveInlineFilters) return this.items;

      const filters = Object.entries(this.inlineFilters || {}).filter(
        ([, filter]) =>
          !(
            filter === "" ||
            filter === null ||
            filter === undefined ||
            (Array.isArray(filter) && filter.length === 0)
          ),
      );
      //////////////////////
      // console.log("FILTROS ACTIVOS:", filters);

      // const cupsPrueba = "ES0031607296580002PR";

      // console.log(
      //   "CONTRATOS CUPS ANTES DE FILTRAR:",
      //   this.items.filter((x) => x.cups === cupsPrueba),
      // );

      // this.items
      //   .filter((x) => x.cups === cupsPrueba)
      //   .forEach((item) => {
      //     console.log("ANALIZANDO:", item.ref);

      //     filters.forEach(([key, filter]) => {
      //       const header = this.headers.find((h) => h.value === key) || {};

      //       console.log({
      //         ref: item.ref,
      //         key,
      //         valor: item?.[key],
      //         filtro: filter,
      //         dataType: header.dataType || "text",
      //         resultado: perColumnFilter(
      //           item?.[key],
      //           filter,
      //           header.dataType || "text",
      //         ),
      //       });
      //     });
      //   });

      //////////////////////

      return this.items.filter((item) =>
        filters.every(([key, filter]) => {
          const header = this.headers.find((h) => h.value === key) || {};
          return perColumnFilter(
            item?.[key],
            filter,
            header.dataType || "text",
          );
        }),
      );
    },
    visibleItems() {
      if (this.serverPagination) return this.items;

      const start = (this.page - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      return this.filteredItemsForDisplay.slice(start, end);
    },
    paginationLength() {
      if (this.serverPagination) return this.pageCount;
      return Math.max(
        1,
        Math.ceil(this.filteredItemsForDisplay.length / this.rowsPerPage),
      );
    },
    faltanPorCargar() {
      return this.page < this.pageCount;
    },
    hasActiveInlineFilters() {
      return Object.values(this.inlineFilters || {}).some((value) => {
        if (Array.isArray(value)) return value.length > 0;
        if (value === null || value === undefined) return false;
        if (typeof value === "string") return value.trim().length > 0;
        return true;
      });
    },
  },
  methods: {
    parseDate,
    async getItems(page = this.page) {
      this.loading = true;
      const { data } = await axios({
        method: "GET",
        url: `/contratos`,
        params: {
          page,
          per_page: this.backendPerPage,
        },
      });

      this.serverPagination = true;
      this.globalFilterMode = false;
      this.items = data.items || [];
      this.count = data.total_items || 0;
      this.pagesize = data.pagesize || this.pagesize;
      this.loadsize = data.loadsize || this.backendPerPage;
      this.tableItemsPerPage = this.rowsPerPage;
      this.pageCount =
        data.total_pages ||
        Math.max(1, Math.ceil(this.count / this.backendPerPage));
      this.loading = false;
    },
    async enableGlobalFilterMode() {
      if (this.globalFilterMode) return;

      this.loading = true;

      const perPage = this.maxSearchPerPage;
      const { data: firstPage } = await axios({
        method: "GET",
        url: `/contratos`,
        params: {
          page: 1,
          per_page: perPage,
        },
      });

      const firstItems = firstPage.items || [];
      const totalItems = firstPage.total_items || firstItems.length;
      const totalPages =
        firstPage.total_pages || Math.max(1, Math.ceil(totalItems / perPage));

      let allItems = [...firstItems];

      for (let page = 2; page <= totalPages; page++) {
        const { data } = await axios({
          method: "GET",
          url: `/contratos`,
          params: {
            page,
            per_page: perPage,
          },
        });
        allItems = [...allItems, ...(data.items || [])];
      }

      this.items = allItems;
      this.count = totalItems;
      this.serverPagination = false;
      this.globalFilterMode = true;
      this.page = 1;
      this.tableItemsPerPage = this.rowsPerPage;
      this.pageCount = Math.max(
        1,
        Math.ceil(allItems.length / this.rowsPerPage),
      );
      this.loading = false;
    },
    async onInlineFiltersChange() {
      if (this.hasActiveInlineFilters) {
        const wasGlobalMode = this.globalFilterMode;
        await this.enableGlobalFilterMode();
        if (wasGlobalMode) this.page = 1;
        return;
      }

      if (this.globalFilterMode) {
        this.page = 1;
        await this.getItems(1);
      }
    },
    syncScroll(event) {
      const scrollTop = this.$refs.scrollTop;
      // Sincroniza el desplazamiento del scroll superior al inferior
      if (scrollTop) {
        scrollTop.scrollLeft = event.target.scrollLeft;
      }
    },
    async getHeaders() {
      this.loading = true;
      const { data } = await axios({
        method: "GET",
        url: `/contratos/headers`,
      });

      (this.headers = data.map((header) => {
        return {
          class: "text-no-wrap sticky-header",
          cellClass: "pa-2 text-no-wrap",
          filter: (value) =>
            perColumnFilter(
              value,
              this.inlineFilters[header.value],
              header.dataType,
            ),
          dataType: "text",
          ...header,
        };
      })),
        (this.loading = false);
    },
    async exportarTodos() {
      this.exporting = true;
      let filters = this.inlineFilters;

      if (this.selected?.length > 0) filters["ref"] = this.selected;

      try {
        const { data: excel } = await axios({
          method: "POST",
          url: `/contratos/exportacion`,
          data: {
            filters: filters,
          },
          responseType: "blob",
        });
        downloadFile(new File([excel], "contratos_exportados.xlsx", {}));
      } catch {
        this.$root.$emit("snack", "Ha ocurrido un error en la exportación");
      } finally {
        this.exporting = false;
      }
    },
  },
  mounted() {
    this.getItems(1);
    this.getHeaders();
  },
  watch: {
    page(n, o) {
      if (n !== o && this.serverPagination) this.getItems(n);
    },
    paginationLength(n) {
      if (this.page > n) this.page = 1;
    },
    inlineFilters: {
      deep: true,
      handler() {
        this.onInlineFiltersChange();
      },
    },
  },
};
</script>

<style>
.contratos-page {
  max-width: none;
  width: 100%;
  padding-left: 4%;
  padding-right: 4%;
  box-sizing: border-box;
}

.table-container {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

.scroll-top {
  overflow-x: auto;
  margin-bottom: 10px;
  /* Espacio entre el scroll superior y la tabla */
}

.v-table {
  max-width: 100%;
  overflow-x: auto;
}
</style>
